import React, { useState, useEffect } from 'react'
import Plot from 'react-plotly.js'
import { Select } from 'antd'
import axios from 'axios'
import { useSelectedWeek } from '../../../../../../contexts/SelectedWeekContext'
import { computeSelectedWeekForSeason, getWeekFromWeek, getYearFromWeek, SeasonRange, seasonReferenceYear } from '../../../../../../../_metronic/helpers'

const { Option } = Select
interface WeeklyData {
  nCriticalNowcastIRAUTVIRUS: number | null
  nCriticalNowcastFLU: number | null
  //percentIRGENERALE: number
  nCriticalNowcastRSV: number | null
  nCriticalNowcastCOVID19: number | null
  lowerCiBaselineNCritical: number | null
  upperCiBaselineNCritical: number | null
  nCriticalNowcastall: number | null
}
interface AvregData {
  week: number
  percent: number
}
interface WeeklyReport {
  [week: string]: WeeklyData
}
interface Trace {
  x: string[]
  y: (number | null)[]
  type: string
  mode: string
  marker?: { color: string }
  line?: { color: string }
  yaxis?: string
  name: string
}
interface StreamgraphChartProps {
  season: SeasonRange
  selectedDiagnosisCategories: string[]
  setSelectedDiagnosisCategories: (v: any) => void
}

const StreamgraphChart: React.FC<StreamgraphChartProps> = ({ season, selectedDiagnosisCategories, setSelectedDiagnosisCategories }) => {
  const [data, setData] = useState<WeeklyReport>({})
  const [avergeData, setAvergeData] = useState<AvregData[]>([])
  const { selectedWeek, setSelectedWeek } = useSelectedWeek('2025-W40')
  // const [selectedDiagnosisCategories, setSelectedDiagnosisCategories] = useState<string[]>([
  //   'trace5',
  // ])

  const [seasonSelectedWeek, setSeasonSelectedWeek] = useState<string | null>(null)
  const startYear = getYearFromWeek(season.startWeek)
  const endYear = getYearFromWeek(season.endWeek)
  const startWeekNumber = getWeekFromWeek(season.startWeek) + 1

  const API_URL = process.env.REACT_APP_API_URL
  const [plotData, setPlotData] = useState<Trace[]>([])
  const [plotUpdateData, setPlotUpdateData] = useState<Trace[]>([])
  const [showArrow, setShowArrow] = useState<boolean>(false)
  function addMissingWeek(data: WeeklyReport): WeeklyReport {
    const startWeek = season.startWeek
    const endWeek = season.endWeek
    const newData: WeeklyReport = {}

    let currentWeek = startWeek

    while (true) {
      if (!data[currentWeek]) {
        newData[currentWeek] = {
          nCriticalNowcastIRAUTVIRUS: null,
          nCriticalNowcastFLU: null,
          nCriticalNowcastRSV: null,
          nCriticalNowcastCOVID19: null,
          lowerCiBaselineNCritical: null,
          upperCiBaselineNCritical: null,
          nCriticalNowcastall: null,
        }
      }

      if (currentWeek === endWeek) break
      // Increment the week
      const [year, weekNum] = currentWeek.split('-W')
      let weekNumber = parseInt(weekNum, 10)
      let nextYear = parseInt(year, 10)
      if (weekNumber === 52) {
        weekNumber = 1
        nextYear++
      } else {
        weekNumber++
      }
      currentWeek = `${nextYear}-W${weekNumber.toString()}`
    }

    // Merge the newly added missing weeks into the existing data
    const mergedData: WeeklyReport = { ...data, ...newData }

    return mergedData
  }
  const addMissingViruses = (data: WeeklyReport): WeeklyReport => {
    const viruses = [
      'nCriticalNowcastFLU',
      'nCriticalNowcastCOVID19',
      'nCriticalNowcastRSV',
      'nCriticalNowcastIRAUTVIRUS',
      'nCriticalNowcastall',
    ]

    for (const week in data) {
      for (const virus of viruses) {
        if (!(virus in data[week])) {
          data[week][virus] = 0
        }
      }
    }

    return data
  }

  const fetchData = async () => {
    try {
      const response = await axios.get(API_URL + `/icuAdmissionsRespiratorySyndromsDiagnosis/list`)
      const startWeek = season.startWeek
      const endWeek0 = season.endWeek

      let missingData: WeeklyReport = {}
      let currentWeek = startWeek

      // Transformer l'objet en tableau
      const weeksArray = Object.entries(response.data).map(([week, values]) => ({
        week,
        ...(values as Record<string, any>),
      }));

      while (true) {
        if (!response.data[currentWeek]) {
          missingData[currentWeek] = {
            nCriticalNowcastIRAUTVIRUS: null,
            nCriticalNowcastFLU: null,
            nCriticalNowcastRSV: null,
            nCriticalNowcastCOVID19: null,
            lowerCiBaselineNCritical: null,
            upperCiBaselineNCritical: null,
            nCriticalNowcastall: null,
          }
        }

        if (currentWeek === endWeek0) break
        // Increment the week
        const [year, weekNum] = currentWeek.split('-W')
        let weekNumber = parseInt(weekNum, 10)
        let nextYear = parseInt(year, 10)
        if (weekNumber === 52) {
          weekNumber = 1
          nextYear++
        } else {
          weekNumber++
        }
        currentWeek = `${nextYear}-W${weekNumber.toString()}`
      }
      //setAvergeData(response2.data)
      setData(addMissingViruses(addMissingWeek(response.data)))

      let data: WeeklyReport = addMissingViruses(addMissingWeek(response.data))

      //addMissingWeek(data)
      const sortedData = Object.entries(data)
        .filter(([week]) => {
          const currentYear = parseInt(week.substring(0, 4), 10)
          const currentWeek = parseInt(week.substring(week.indexOf('-W') + 2), 10)
          // return (currentYear === 2025 && currentWeek >= 36) || currentYear > 2025
          return (
            (currentYear === startYear && currentWeek >= startWeekNumber) ||
            (currentYear === endYear && currentWeek <= 27) ||
            (currentYear > startYear && currentYear < endYear)
          );
        })
        .sort(([a], [b]) => {
          const aYear = parseInt(a.substring(0, 4), 10)
          const aWeek = parseInt(a.substring(a.indexOf('-W') + 2), 10)
          const bYear = parseInt(b.substring(0, 4), 10)
          const bWeek = parseInt(b.substring(b.indexOf('-W') + 2), 10)
          if (aYear !== bYear) {
            return aYear - bYear
          } else {
            return aWeek - bWeek
          }
        })

      let endWeek = season?.endWeek?.split('-W')
      const alignedWeek =
        startYear == seasonReferenceYear
          ? selectedWeek
          : computeSelectedWeekForSeason(selectedWeek, season.startWeek)
      const selectWeek = alignedWeek.split('-W')
      const showArrow =
        (Number(selectWeek[0]) > startYear ||
          (Number(selectWeek[0]) === startYear && Number(selectWeek[1]) >= startWeekNumber)) &&
        (Number(selectWeek[0]) < Number(endWeek[0]) ||
          (Number(selectWeek[0]) === Number(endWeek[0]) &&
            Number(selectWeek[1]) <= Number(endWeek[1])))
      setShowArrow(showArrow)
      setSeasonSelectedWeek(alignedWeek);

      const trace1 = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.nCriticalNowcastFLU),
        type: 'scatter',
        yaxis: 'y',
        mode: 'lines',
        marker: { color: '#6610f2' },
        name: 'number of ICU admissions for respiratory syndromes - Influenza',
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }

      const trace2 = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.nCriticalNowcastCOVID19),
        type: 'scatter',
        yaxis: 'y',
        mode: 'lines',
        line: { color: '#672079' },
        name: 'number of ICU admissions for respiratory syndromes - SARS-CoV-2',
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }
      const trace3 = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.nCriticalNowcastRSV),
        type: 'scatter',
        yaxis: 'y',
        mode: 'lines',
        marker: { color: '#0d6efd' },
        name: 'number of ICU admissions for respiratory syndromes - RSV',
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }

      const trace4 = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.nCriticalNowcastIRAUTVIRUS),
        type: 'scatter',
        yaxis: 'y',
        mode: 'lines',
        line: { color: '#00d9d9' },
        name: 'number of ICU admissions for respiratory syndromes - Other respiratory infections',
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }

      const trace5 = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.nCriticalNowcastall),
        type: 'scatter',
        yaxis: 'y',
        mode: 'lines',
        line: { color: '#203879' },
        name: 'number of ICU admissions for respiratory syndromes - All viruses',
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }
      const tracemin = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.lowerCiBaselineNCritical),
        //y: Object.values(data).map((entry) => entry.lowerCiBaselineNCritical),
        fill: 'tonexty',
        type: 'scatter',
        mode: 'lines',

        line: { color: 'lightgrey', dash: 'dashdot' },
        name: 'Statistical range of normal percentage*',
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }

      const tracemax = {
        x: sortedData.map(([week]) => week),
        y: sortedData.map(([, entry]) => entry.upperCiBaselineNCritical),
        //y: Object.values(data).map((entry) => entry.upperCiBaselineNCritical),

        type: 'scatter',

        mode: 'lines',
        line: { color: '#BBBBBC', dash: 'dashdot' },
        name: 'All viruses',
        showlegend: false,
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }

      const missdata = {
        x: Object.entries(missingData).map(([week]) => week),
        y: Object.entries(missingData).map(([, entry]) => 0),
        type: 'scatter',
        mode: 'markers',

        name: 'Missing Data',
        marker: { color: '#000000' },
        hovertemplate:
          '<b>%{fullData.name}</b><br>' +
          'Week: %{x}<br>' +
          '%{fullData.name}: %{y}<extra></extra>',
      }
      setPlotData([tracemax, tracemin, trace1, trace2, trace3, trace4, trace5, missdata])

      let updatedPlotData: Trace[] = []

      if (
        selectedDiagnosisCategories.includes('trace5') &&
        selectedDiagnosisCategories.length <= 1
      ) {
        updatedPlotData.push(tracemax)
        updatedPlotData.push(tracemin)
      }

      if (selectedDiagnosisCategories.includes('trace1')) {
        updatedPlotData.push(trace1)
      }
      if (selectedDiagnosisCategories.includes('trace2')) {
        updatedPlotData.push(trace2)
      }
      if (selectedDiagnosisCategories.includes('trace3')) {
        updatedPlotData.push(trace3)
      }
      if (selectedDiagnosisCategories.includes('trace4')) {
        updatedPlotData.push(trace4)
      }
      if (selectedDiagnosisCategories.includes('trace5')) {
        updatedPlotData.push(trace5)
      }
      updatedPlotData.push(missdata)
      setPlotUpdateData(updatedPlotData)
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error or set a default value for data
      setData({})
    }
  }
  useEffect(() => {
    fetchData()
  }, [selectedWeek, selectedDiagnosisCategories])

  // useEffect(() => {
  //   setSelectedDiagnosisCategories(['trace5'])
  // }, [])

  // const trace5 = {
  //     x: Object.keys(data).filter((entry) => entry >= '2023-W35'),
  //   y: Object.values(data).map((entry) => entry.percentIRGENERALE),
  //   type: 'scatter',
  //   yaxis: 'y2',
  //   mode: 'lines',
  //   line: {color: '#ed7d31'},
  //   name: 'Cases',
  // }

  // const trace6 = {
  //   x: avergeData.map((entry) => entry.week),
  //   y: avergeData.map((entry) => entry.percent),
  //   type: 'scatter',
  //   yaxis: 'y2',
  //   mode: 'lines',
  //   line: {color: '#ffc700'},
  //   name: '% Cases',
  // }

  const layout = {
    title: `Number of ICU admissions of patients with a diagnosis of respiratory syndromes`,
    barmode: 'stack',
    bargap: 0.2, // Adjust the gap between bars
    bargroupgap: 0.1, // Adjust the gap between bar groups
    autosize: true,

    annotations: [
      {
        xref: 'paper',
        yref: 'paper',
        x: -0.035,
        xanchor: 'right',
        y: 0.4,
        yanchor: 'bottom',
        text: '#',
        font: {
          size: 25,

          //color: '#BBBBBC',
        },
        showarrow: false,
      },
      {
        x: startYear == 2025 ? selectedWeek : seasonSelectedWeek,
        y: 0,
        xref: 'x',
        yref: 'y',
        text: showArrow ? 'Selected Week' : '',
        font: {
          family: 'Courier New, monospace',
          size: 16,
          color: '#CC1B1B',
        },
        arrowcolor: '#CC1B1B',
        showarrow: showArrow,
        arrowhead: 7,
        ax: 0,
        ay: -170,
      },
      // {
      //   xref: 'paper',
      //   yref: 'paper',
      //   x: 1.01,
      //   xanchor: 'left',
      //   y: 0.4,
      //   yanchor: 'bottom',
      //   text: 'min-max',
      //   font: {
      //     size: 12,

      //     color: '#BBBBBC',
      //   },
      //   showarrow: false,
      // },
    ],

    xaxis: {
      title: 'Weeks',
      autorange: true,
      type: 'category',
      tickangle: -45,
    },
    yaxis: {
      // autorange: true,
      range: [0, null],
    },
    yaxis2: {
      showgrid: false,
      titlefont: { color: 'rgb(148, 103, 189)' },
      tickfont: { color: 'rgb(148, 103, 189)' },
      overlaying: 'y',
      side: 'right',
      range: [0, null],
    },
    legend: {
      x: 0,
      y: -0.5,
      orientation: 'h',
    },
  }

  const handleDataChangeVirus = async (values: string[]) => {
    if (values.length === 0) {
      let updatedPlotData: Trace[] = []
      setSelectedDiagnosisCategories(['trace5'])
      updatedPlotData.push(plotData[0])
      updatedPlotData.push(plotData[1])
      updatedPlotData.push(plotData[6])
      setPlotUpdateData(updatedPlotData)
    } else {
      setSelectedDiagnosisCategories(values)

      let updatedPlotData: Trace[] = []
      if (values.includes('trace5') && values.length <= 1) {
        updatedPlotData.push(plotData[0])
        updatedPlotData.push(plotData[1])
      }

      if (values.includes('trace1')) {
        updatedPlotData.push(plotData[2])
      }
      if (values.includes('trace2')) {
        updatedPlotData.push(plotData[3])
      }
      if (values.includes('trace3')) {
        updatedPlotData.push(plotData[4])
      }
      if (values.includes('trace4')) {
        updatedPlotData.push(plotData[5])
      }
      if (values.includes('trace5')) {
        updatedPlotData.push(plotData[6])
      }
      updatedPlotData.push(plotData[7])
      setPlotUpdateData(updatedPlotData)
    }
  }

  return (
    <>
      <div className='row mt-2'>
        <label style={{ width: '10%' }} className='col-1 mt-3 text-primary fw-medium fs-5'>
          Virus :
        </label>
        <div className='col-6'>
          <Select
            mode='multiple'
            variant='borderless'
            className='border border-gray-500 border-3 rounded'
            style={{ width: '72.5%' }}
            size='large'
            value={selectedDiagnosisCategories}
            onChange={(value, option) => handleDataChangeVirus(value)}
          >
            <Option key={'trace5'} value={'trace5'}>
              {'All viruses'}
            </Option>
            <Option key={'trace1'} value={'trace1'}>
              {'Influenza'}
            </Option>
            <Option key={'trace2'} value={'trace2'}>
              {'SARS-CoV-2'}
            </Option>
            <Option key={'trace3'} value={'trace3'}>
              {'RSV'}
            </Option>
            <Option key={'trace4'} value={'trace4'}>
              {'Other respiratory infections'}
            </Option>
          </Select>
        </div>
      </div>
      <div className='plotContainer'>
        <Plot
          style={{ width: '100%', height: '400px' }}
          data={plotUpdateData}
          layout={layout}
          config={{
            displaylogo: false,
            responsive: true,
          }}
        />
      </div>
    </>
  )
}
export default StreamgraphChart
